<template>
  <div class="hello">
    <div v-if="!form" class="dynamic-container">
      <br><br><br><br><br>
      <h1>Tävlingen är avslutad!</h1>
      <div class="divider"></div>
      <!--<p>Öppna porten genom att skriva in de fyra sista siffrorna på streckkoden från fem produkter från Cloetta. Då har du chans att vinna en nöjesbiljett från Parks and Resorts. Den gäller för två vuxna och två barn hos antingen Gröna Lund, Kolmården, Furuvik eller Skara Sommarland.</p>
      -->
      <!--<Port :open="open" />-->
      <!--<CodeInput @correct="openDoor" :door="open" />-->
    </div>
    <WinnerForm v-if="form" @resetall="restart" :codes="codes" />
    <div class="balloons">
      <div class="ball balloon1">
        <Balloon />
      </div>
      <div class="ball balloon2">
        <Balloon />
      </div>
      <div class="ball balloon3">
        <Balloon />
      </div>
      <div class="ball balloon4">
        <Balloon />
      </div>
      <div class="ball balloon5">
        <Balloon />
      </div>
    </div>
    <div class="ground">
      <div class="animals">
        <img src="./../assets/images/djur_new.svg">
      </div>
      <div class="wheel-1">
        <Wheel />
      </div>
      <div class="wheel-2">
        <Wheel />
      </div>
      <div class="slide">
      </div>
    </div>
  </div>
</template>

<script>
import Balloon from '@/components/Balloon'
import Wheel from '@/components/Wheel'
import Port from '@/components/Port'
import CodeInput from '@/components/CodeInput'
import WinnerForm from '@/components/WinnerForm'

export default {
  name: 'Start',
  data () {
    return {
      msg: 'Cloetta',
      open: false,
      form: false,
      codes: null
    }
  },
  components: {
    Balloon,
    Wheel,
    Port,
    CodeInput,
    WinnerForm
  },
  methods: {
    openDoor (codes) {
      this.codes = codes
      this.open = true
      window.setTimeout(() => {
        this.form = true
      }, 4000)
    },
    restart () {
      location.reload()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .hello {
    display: block;
    min-height: 91%;
    background-image: url('./../assets/images/back-modified-min.png');
    background-size: auto 100%;
    background-position: left center;
    position: relative;
    overflow: hidden;
  }
  .ground {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 30vh;
  }
  .balloons .ball {
    height: 25vh;
    width: 25vh;
    position: fixed;
  }
  .animals {
    position: absolute;
    bottom: -1.8vh;
    z-index: 10;
    width: 100%;
    text-align: center;
  }
  .animals img {
    height: 22vw;
    max-height: 150px;
    width: auto;
  }
  .balloon1 {
    top: 38vh;
    left: -22vw;
    transform: scale(0.7);
  }
  .balloon2 {
    top: -3.3vh;
    left: -16vw;
    transform: scale(0.17);
  }
  .balloon3 {
    top: 19vh;
    left: -5vw;
    transform: scale(0.3);
  }
  .balloon4 {
    top: 26vh;
    right: -8vw;
    transform: scale(0.38);
  }
  .balloon5 {
    top: 5vh;
    right: -30vw;
    transform: scale(0.8);
  }
  @media only screen and (min-width: 660px) {
    .balloon1 {
      top: 35vh;
      left: 10vw;
      transform: scale(0.8);
    }
    .balloon2 {
      top: 10vh;
      left: 24vw;
      transform: scale(0.18);
    }
    .balloon3 {
      top: 13vh;
      left: 5vw;
      transform: scale(0.3);
    }
    .balloon4 {
      top: 10vh;
      right: 20vw;
      transform: scale(0.3);
    }
    .balloon5 {
      top: 5vh;
      right: 10vw;
      transform: scale(0.8);
    }
  }
  .wheel-1 {
    position: absolute;
    height: 30vh;
    width: 30vh;
    left: -18vh;
    bottom: -4vh;
    transform: scaleX(-1);
  }
  .wheel-2 {
    position: absolute;
    height: 30vh;
    width: 30vh;
    right: -5vw;
    bottom: -10vh;
    transform-origin: 50% 50%;
    transform: scale(0.4);
    opacity: 0.75;
  }
  @media only screen and (min-width: 660px) {
    .wheel-1 {

      height: 30vh;
      width: 30vh;
      left: 40vh;
      bottom: -4vh;
    }
    .wheel-2 {
      height: 30vh;
      width: 30vh;
      right: 5vw;
      bottom: -10vh;
      transform-origin: 50% 50%;
      transform: scale(0.4);
      opacity: 0.75;
    }
  }
  .slide {
    background-image: url('./../assets/images/slide.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center bottom;
    width: 76%;
    height: 180%;
    position: absolute;
    right: -17vh;
    bottom: -1vh;
  }
  .dynamic-container {
    position: relative;
    z-index: 99;
  }
  h1 {
    font-size: 4.3vh;
    width: 84vw;
    max-width: 500px;
    margin: auto;
    display: block;
    margin-top: 2.4vh;
    margin-bottom: 1.3vh;
    line-height: 1.1em;
  }
  .divider {
    width: 55vw;
    max-width: 400px;
    height: 1px;
    background-color: #fff;
    margin: auto;
  }
  p {
    width: 86vw;
    max-width: 500px;
    font-size: 2.2vh;
    margin: auto;
    display: block;
    margin-top: 1.1vh;
    line-height: 1.12em;
  }
  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-zoom-enter-active {
    transition: all .3s ease;
  }
  .slide-zoom-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: scale(6);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Start.vue